import React from 'react';

const empty = undefined;

const FirebaseContext = React.createContext(empty);

export default FirebaseContext;
